import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  rohDetails: [],
  isLoading: false,
  error: "",
  hasData: false
};
const rohSlice = createSlice({
  name: "roh",
  initialState,
  reducers: {
    getROHDataRequest: (state, action) => {
      state.isLoading = true;
    },
    getROHDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.rohDetails = action.payload;
    },
    getROHDataFail: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});
export const {
  getROHDataRequest,
  getROHDataSuccess,
  getROHDataFail
} = rohSlice.actions;
export default rohSlice.reducer;